// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Wn_h","header":"ClearentDisclaimer_header__342P3","inner":"ClearentDisclaimer_inner__uRlMa"};